export function GetDateRange(localState,theName, theValue) {
  let dateFrom = new Date(localState.from)
  let dateTo = new Date(localState.to)
  if(theName==='from'){
    dateFrom = new Date(theValue)
    if(dateFrom.getMonth() !== dateTo.getMonth()){
      const nextMonth = new Date(dateFrom.getFullYear(), dateFrom.getMonth() + 1, 1);
      dateTo = new Date(nextMonth - 1);
    }
  }else{
    dateTo = new Date(theValue)
    if(dateFrom.getMonth() !== dateTo.getMonth()){
      dateFrom = new Date(dateTo.getFullYear(), dateTo.getMonth(), 1);
    }
  }

  const theStartDate = dateFrom.toISOString().slice(0, 10)
  const theEndDate = dateTo.toISOString().slice(0, 10)

  return [theStartDate, theEndDate]
}


